/* RESPONSIBLE TEAM: team-reporting */
import Route from '@ember/routing/route';

export default class ManageRoute extends Route {
  // This parent route ensures proper nesting under reports
}
